const resetpassword = {
  EN: {
    popTitle: 'Password Recovery',
    popText: 'Please enter your email or phone number to send a passcode for password reset',
    title: 'Password Reset',
    text: 'We have just sent a verification code to your provided details',
    submit: 'Submit',
    email: 'Email',
    phone: 'Phone',
    ref: 'Reference Number',
    verification: 'Verification Code*',
    newPassword: 'New Password*',
    confirmPassword: 'Confirm Password*',
    reset: 'Reset',
    cancel: 'Cancel',
  },
  TH: {
    popTitle: 'กู้คืนรหัสผ่าน',
    popText: 'โปรดกรอกอีเมลหรือหมายเลขโทรศัพท์ของคุณเพื่อรับรหัสยืนยันสำหรับการตั้งรหัสผ่านใหม่',
    title: 'ตั้งรหัสผ่านใหม่',
    text: 'เราได้ส่งรหัสยืนยันไปยังข้อมูลที่คุณให้ไว้',
    submit: 'ยืนยัน',
    email: 'อีเมล',
    phone: 'หมายเลขโทรศัพท์',
    ref: 'หมายเลขอ้างอิง',
    verification: 'รหัสยืนยัน',
    newPassword: 'รหัสผ่านใหม่*',
    confirmPassword: 'ยืนยันรหัสผ่าน*',
    reset: 'ตั้งใหม่',
    cancel: 'ยกเลิก',
  },
};

export default resetpassword;
